import Vue from "vue";
import Vuex from "vuex";
import Cookies from 'js-cookie'

Vue.use(Vuex);

export const SET_TOKEN = 'SET_TOKEN';
export const MOVE_TOKEN = 'MOVE_TOKEN';
export const SET_BROWHEADERTITLE = 'SET_BROWHEADERTITLE';

export default new Vuex.Store({
  state: {
    webTitle: '安丘市教师进修学校',
    webSmallTitle: '专业技术人员继续教育基地',
    canSignUp: '项目学习已结束，不再提供报名以及选课服务！',
    recordStudy: '项目学习已结束，学习记录将不会保存，相关学习不会产生新的学时！',
    images: [
      '/static/img/index/learning.png',
      '/static/img/index/running.png',
      '/static/img/index/finished.png',
      '/static/img/index/approval.png',
      '/static/img/index/crowdfunding.png'
    ],
    noMoreImage: '/static/img/pro/no-more.png',
    defaultCourseImg: '/static/img/pro/course_default.png',
    jingduImgs: [
      '/static/img/pro/jindu0.png',
      '/static/img/pro/jindu1.png',
      '/static/img/pro/jindu2.png',
      '/static/img/pro/jindu3.png'
    ],
    PaymentTypeEnum: {
      'preview': 'preview',   //预览
      'free': 'free',        //免费
      'charge': 'charge',    //收费
      'solely': 'solely',   //套餐
      'share': 'share',    //分享
      'creator': 'creator' //制作
    },
    ProjectCertificateStatusEnum: {
      'process': 'process',   //处理中
      'finished': 'finished',        //已完成
      'error': 'error',    //出错
    },
    LetterList: [
      'A',
      'B',
      'C',
      'D',
      'E',
      'F',
      'G',
      'H',
      'I',
      'J',
      'K',
      'L',
      'M',
      'N',
      'O',
      'P',
      'Q',
      'R',
      'S',
      'T',
      'U',
      'V',
      'W',
      'X',
      'Y',
      'Z'
    ],
    defaultNewsImg: '/static/img/index/default-news.png',
    page: {
      index: 1,
      size: 10
    },
    teachPage: {
      index: 1,
      size: 4
    },
    orderStatus: {
      'expired': '已过期',
      'prepaying': '待预付',
      'pricing': '已预付',
      //topay 包含预付项目支付尾款 和 课程/非预付项目 支付 ，根据presale字段区分
      'topay': '待支付',
      'unpaid': '待支付',
      'success': '已支付',
      'closed': '已关闭',
      // 'canceled': '已取消',
      'refund': '已退款',
      'failed': '已失败',
      'error': '有异常',
      'unknown': '有问题',
    },
    channelText: {
      'wxpay': '微信',
      'alipay': '支付宝',
      'balance': '余额支付',
    },
    ContentTypeEnum: {
      NEWS: {
        value: 'news', label: '资讯', color: 'success', logo: 'content-news'
      },
      LINK: {
        value: 'link', label: '链接', color: 'error', logo: 'content-link'
      },
      PROJECT: {
        value: 'project', label: '项目', color: 'processing', logo: 'content-project'
      },
      COURSE: {
        value: 'course', label: '课程', color: 'default', logo: 'content-course'
      },
      USER: {
        value: 'user', label: '人员', color: 'warning', logo: 'content-people'
      },
      SERIAL: {
        value: 'serial', label: '专栏', color: 'success', logo: 'content-zhuanlan'
      },
      IMAGE: {
        value: 'image', label: '模板', logo: 'content-template'
      },
      STATIC: {
        value: 'static', label: '静态内容', logo: 'content-template'
      }
    },
    uploadresUrl: '//res.aqjsjx.com.cn/',
    anqiu_education_token: Cookies.get('anqiu_education_token') ? Cookies.get('anqiu_education_token') : '',
    anqiu_education_refresh_token: Cookies.get('anqiu_education_refresh_token') ? Cookies.get('anqiu_education_refresh_token') : '',
    u_info: Cookies.get(' u_info') ? Cookies.get(' u_info') : {},
    browserHeaderTitle: ''
  },
  getters: {
    browserHeaderTitle(state) {
      return state.browserHeaderTitle;
    }
  },
  mutations: {
    // 存入cookie
    [SET_TOKEN](state, token) {
      Cookies.set(token.name.key, token.name.value, token.options);
    },
    [MOVE_TOKEN](state, token) {
      Cookies.remove(token.name.key, token.options);
    },
    [SET_BROWHEADERTITLE](state, token) {
      state.browserHeaderTitle = token.browserHeaderTitle;
      window.document.title = token.browserHeaderTitle;
    }
  },
  actions: {
    getHome(context, payload) {
      let url = Vue.$baseUrl + '/content/content/map';
      return Vue.utils.http.get(url, payload);
    },
    getLecturersList(context, payload) {
      let url = '/static/json/expert.json';
      return Vue.utils.http.get(url, payload);
    },
    getLectureById(context, payload) {
      let url = Vue.$baseUrl + '/user/info/' + payload.id;
      return Vue.utils.http.get(url, payload);
    },
    getProjectsList(context, payload) {
      let url = '/static/json/project.json';
      return Vue.utils.http.get(url, payload);
    },
    getZhuanlanList(context, payload) {
      let url = '/static/json/indexCourse.json';
      return Vue.utils.http.get(url, payload);
    },
    getProjectForLearner(context, payload) {
      let url = Vue.$baseUrl + '/project/learner/project/' + payload.id;
      return Vue.utils.http.get(url, payload);
    },
    getProjectForCreator(context, payload) {
      let url = Vue.$baseUrl + '/project/creator/project/' + payload.id;
      return Vue.utils.http.get(url, payload);
    },
    getSubjectHome(context, payload) {
      let url = '/static/json/video_roof.json';
      return Vue.utils.http.get(url, payload);
    },
    getCourseHome(context, payload) {
      let url = '/static/json/video_roof.json';
      return Vue.utils.http.get(url, payload);
    },
    getCourseMuluList(context, payload) {
      let url = '/static/json/courseMulu.json';
      return Vue.utils.http.get(url, payload);
    },
    userLogin(context, payload) {
      let url = Vue.$baseUrl + '/oauth/token';
      return Vue.utils.http.post(url, payload);
    },
    //获取资源
    getContent(context, payload) {
      let url = this.state.uploadresUrl + payload.content;
      return Vue.utils.http.get(url, payload);
    },
    //获取用户信息
    getUserInfo(context, payload) {
      let url = Vue.$baseUrl + '/user/info/';
      return Vue.utils.http.get(url, payload);
    },
    //获取个人账户信息
    getCurrentUser(context, payload) {
      let url = Vue.$baseUrl + '/me';
      return Vue.utils.http.get(url, payload);
    },
    //获取用户的基本信息
    getUserBaseInfo(context, payload) {
      let url = Vue.$baseUrl + '/user/user-info/' + payload;
      return Vue.utils.http.get(url, payload);
    },

    //重置用户密码
    resetUserPassword(context, payload) {
      let url = Vue.$baseUrl + '/me/password/reset';
      return Vue.utils.http.put(url, payload);
    },
    //注册
    registerUserByAttemptCode(context, payload) {
      let url = Vue.$baseUrl + '/me';
      return Vue.utils.http.post(url, payload);
    },
    getServerCurrentTimeUrl(context, payload) {
      let url = Vue.$baseUrl.split('/').slice(0, -1).join('/') + '/currentTime';
      return Vue.utils.http.get(url, payload);
    },
    updateUserExamFinishedUrl(context, payload) {
      let url = Vue.$baseUrl + '/session-exam/learner/exam/' + payload.examId + '/' + payload.userExamId + '/finished';
      return Vue.utils.http.put(url, payload);
    },
    addUserExamUrl(context, payload) {
      let url = Vue.$baseUrl + '/session-exam/learner/exam/' + payload.id;
      return Vue.utils.http.post(url, payload);
    },
    getUserExamForLearnerUrl(context, payload) {
      let url = Vue.$baseUrl + '/session-exam/learner/exam/' + payload.examId + '/' + payload.userExamId;
      return Vue.utils.http.get(url, payload);
    },
    updateUserExamItemUrl(context, payload) {
      let url = Vue.$baseUrl + '/session-exam/learner/exam/' + payload.examId + '/' + payload.userExamId + '/item/' + payload.examItemId;

      return Vue.utils.http.put(url, payload.model);
    },
    //获取单条内容对象
    getContentUrl(context, payload) {
      let url = Vue.$baseUrl + '/content/content/' + payload.id;
      return Vue.utils.http.get(url, payload);
    },
    learnVideoSession(context, payload) {
      let url = Vue.$baseUrl + '/session-video/learner/video/' + payload.id;
      return Vue.utils.http.put(url, payload.model);
    },
    //byId获取课程对象（学习使用：包括课程基础信息、章节、小节、用户课程情况、用户小节情况）
    getCourseForLearner(context, payload) {
      let url = Vue.$baseUrl + '/course/learner/course/_/' + payload.id;
      return Vue.utils.http.get(url, payload);
    },
    getProjectCourseForLearner(context, payload) {
      let url = Vue.$baseUrl + '/project/learner/project/' + payload.proId + '/course/' + payload.id;
      return Vue.utils.http.get(url, payload);
    },
    //获取手机验证码
    sendLoginPhoneVerificationCode(context, payload) {
      let url = Vue.$baseUrl + '/verification-code/token';
      return Vue.utils.http.post(url, payload);
    },
    //腾讯验证码票据验证
    checkTicket(context, payload) {
      let url = Vue.$baseUrl + '/verification-code/ticket';
      return Vue.utils.http.post(url, payload.params);
    },
    //获取首页数据
    getIndexData(context, payload) {
      let url = Vue.$baseUrl + '/content/content/map';
      return Vue.utils.http.get(url, payload);
    },
    //通过Ids获取项目数组
    listProjectByIdsUrl(context, payload) {
      let url = Vue.$baseUrl + '/project/project/list';
      return Vue.utils.http.get(url, payload);
    },
    //项目报名
    addLearnerProject(context, payload) {
      let url = Vue.$baseUrl + '/project/learner/project/' + payload.id;
      return Vue.utils.http.post(url, payload);
    },
    getAppversionAndroid(context, payload) {
      let url = Vue.$baseUrl + '/content/content/map';
      return Vue.utils.http.get(url, payload);
    },

    getSessionDocForLearnerUrl(context, payload) {
      let url = Vue.$baseUrl + '/session-doc/learner/doc/' + payload.id;
      return Vue.utils.http.get(url, payload);
    },
    cancelOrder(context, payload) {
      let url = Vue.$baseUrl + '/trade/order/' + payload.id + '/cancel';
      return Vue.utils.http.put(url, payload);
    },
    getVideoSessionById(context, payload) {
      let url = Vue.$baseUrl + '/session-video/learner/video/' + payload.id;
      return Vue.utils.http.get(url, payload);
    },
    getSessionSignInForLearnerUrl(context, payload) {
      let url = Vue.$baseUrl + '/session-sign-in/learner/sign-in/' + payload.id;
      return Vue.utils.http.get(url, payload);
    },
    updateSessionSignInFinishedUrl(context, payload) {
      let url = Vue.$baseUrl + '/session-sign-in/learner/sign-in/' + payload.id + '/finished';
      return Vue.utils.http.put(url, payload.userSessionSignIn);
    },
    getSessionExamForLearnerUrl(context, payload) {
      let url = Vue.$baseUrl + '/session-exam/learner/exam/' + payload.id;
      return Vue.utils.http.get(url, payload);
    },
    searchContentPublished(context, payload) {
      let url = Vue.$baseUrl + '/content/content/published/search';
      return Vue.utils.http.get(url, payload);
    },
    /// 获取购买项目课程订单
    listLearnerProjectCourseForOrderPreviewUrl(context, payload) {
      let url = Vue.$baseUrl + '/project/learner/project/' + payload.id + '/course/list/order-preview';
      return Vue.utils.http.get(url, payload);
    },
    /// 获取学员项目订单
    getLearnerProjectForOrderPreview(context, payload) {
      let url = Vue.$baseUrl + '/project/learner/project/' + payload.id + '/order-preview';
      return Vue.utils.http.post(url, payload);
    },

    paymentSubmit(context, payload) {
      let url = Vue.$baseUrl + '/project/learner/project/';
      return Vue.utils.http.post(url, payload);
    },
    ////H5支付相关
    getTradeTransactionUrl(context, payload) {
      let url = Vue.$baseUrl + '/trade/order/' + payload.orderId + '/transaction';
      return Vue.utils.http.post(url, payload.params);
    },
    getOrderIdByTransaction(context, payload) {
      let url = Vue.$baseUrl + '/trade/transaction/' + payload.id;
      return Vue.utils.http.get(url, payload);
    },
    getTransactionById(context, payload) {
      let url = Vue.$baseUrl + '/trade/transaction/' + payload.id + '/query';
      return Vue.utils.http.get(url, payload);
    },
    getOrderById(context, payload) {
      let url = Vue.$baseUrl + '/trade/order/' + payload.id;
      return Vue.utils.http.get(url, payload);
    },
    ////获取学员课程和订单
    getLearnerCourseForOrderPreview(context, payload) {
      let url = Vue.$baseUrl + '/course/learner/course/' + payload.id + '/order-preview';
      return Vue.utils.http.get(url, payload);
    },
    getCourseForLearnerUrl(context, payload) {
      let url = Vue.$baseUrl + '/course/learner/course/' + payload.id;
      return Vue.utils.http.post(url, payload.userCourse);
    },
    addLearnerProjectCourseBatchUrl(context, payload) {
      let url = Vue.$baseUrl + '/project/learner/project/' + payload.id+'/course/list';
      return Vue.utils.http.post(url, payload.userProject);
    },
    getProjectCourseListPrice(context, payload) {
      let url = Vue.$baseUrl + '/project/course/price/' + payload.id;
      return Vue.utils.http.get(url, payload);
    },
    listLearnerProjectCourseForOrderPreview(context, payload) {
      let url = Vue.$baseUrl + '/project/learner/project/' + payload.id+'/course/list/order-preview';
      return Vue.utils.http.post(url, payload.userProject);
    },
    addReview(context, payload) {
      let url = Vue.$baseUrl + '/review/review';
      return Vue.utils.http.post(url, payload.model);
    },
    getLike(context, payload) {
      let url = Vue.$baseUrl + '/like/like-topic/'+payload.mainType+'/'+payload.mainId;
      return Vue.utils.http.get(url, payload);
    },
    addLike(context, payload) {
      let url = Vue.$baseUrl + '/like/like';
      return Vue.utils.http.post(url, payload.model);
    },
    cancelLike(context, payload) {
      let url = Vue.$baseUrl + '/like/like-cancel';
      return Vue.utils.http.post(url, payload.model);
    },
    getReview(context, payload) {
      let url = Vue.$baseUrl + '/review/review/'+payload.mainType+'/'+payload.mainId;
      return Vue.utils.http.get(url, payload);
    },
    getCertificateById(context, payload) {
      let url = Vue.$baseUrl + '/project/system/learning-proof';
      return Vue.utils.http.get(url, payload);
    },
    getCommentList(context, payload) {
      let url = Vue.$baseUrl + '/comment/comment/search';
      return Vue.utils.http.get(url, payload);
    },
    addComment(context, payload) {
      let url = Vue.$baseUrl + '/comment/comment';
      return Vue.utils.http.post(url, payload.model);
    },

  }
})
